import style from "./GameSection.module.css";
import CardGameType from "./CardGameType";
import clsx from "clsx";
import JokerHorizontalList, {
  HorizontalScrollGradientColor,
} from "./JokerHorizontalList";
import { AllCardsGames } from "../util/AllCardsGames";
import TwoToneHorizontalSectionChild from "./TwoToneHorizontalSectionChild";

interface GameSectionProps {
  classNameStyle?: string;
  item: Array<{
    title: string;
    URL: string;
    paragraph: string;
    srcImage: string[];
    indicator: string;
    type?: AllCardsGames;
  }>;
  title?: string;
  title2?: string;
  description?: string;
  gradientColor?: HorizontalScrollGradientColor;
  isLearnVideoAvailable?: boolean;
}

const GameSection = ({
  item,
  title,
  title2,
  description,
  classNameStyle,
  gradientColor,
  isLearnVideoAvailable = true,
}: GameSectionProps) => {
  return (
    <div className={clsx(style[`parent-container`], classNameStyle)}>
      <TwoToneHorizontalSectionChild
        titleTone1={title ? title : ""}
        titleTone2={title2 ? title2 : ""}
        description={description}
      >
        <div className={style[`desktop-view`]}>
          <JokerHorizontalList
            items={item}
            isBlurEffectEnable={true}
            renderItem={(game: any, index, isHovered) => (
              <CardGameType
                key={index}
                title={game.text || game.title || "Default Text"}
                URL={game.URL || "#"}
                paragraph={
                  game.paragraph || game.description || "Default description"
                }
                srcImage={game.srcImage || game.urlImage || "defaultImage.jpg"}
                indicatorVideo={game.indicator}
                isHoveredIndex={isHovered}
                isLearnEnable={isLearnVideoAvailable}
                type={game.type}
              />
            )}
            gradientColor={gradientColor}
            showScrollbar={false}
          />
        </div>
        <div className={style[`mobile-view`]}>
          {item.map((game, index) => (
            <CardGameType
              key={index}
              title={game.title}
              URL={game.URL}
              paragraph={game.paragraph}
              srcImage={game.srcImage}
              indicatorVideo={game.indicator}
              isHoveredIndex={false}
              isLearnEnable={isLearnVideoAvailable}
              type={game.type}
            />
          ))}
        </div>
      </TwoToneHorizontalSectionChild>
    </div>
  );
};

export default GameSection;
